export default __webpack_public_path__ + "static/media/banner-7.ebd90b35.jpg";